import IntegrationCard from './IntegrationCard';
import { integrations } from '../data/integrations';

export default function FeaturedIntegrations() {
  const featuredIntegrations = integrations.filter((i) => i.featured);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-[#e4f4ff]/30 rounded-full text-[#22577A] font-medium mb-6">
            <i className="ri-star-fill mr-2"></i>
            Featured Integrations
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-6">
            Most Popular Tools
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Connect with the platforms your audience uses most, all enhanced with AI-powered optimization
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuredIntegrations.map((integration) => (
            <IntegrationCard
              key={integration.id}
              integration={integration}
              size="large"
            />
          ))}
        </div>

        {/* AI Enhancement Callout */}
        <div className="mt-16 bg-gradient-to-r from-[#22577A] to-[#38a3a5] rounded-3xl p-8 lg:p-12 text-white">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center">
                  <i className="ri-ai-generate text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold">AI-Enhanced Integrations</h3>
              </div>

              <h4 className="text-3xl lg:text-4xl font-bold mb-6">
                Every Integration, Supercharged with AI
              </h4>

              <p className="text-lg text-white/90 mb-8 leading-relaxed">
                We don't just connect to your tools—we make them smarter. Our AI agents analyze, optimize, and automate across every integration to deliver better results.
              </p>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#b3d9ff] text-xl mt-1"></i>
                  <span>Automatic content optimization for each platform</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#b3d9ff] text-xl mt-1"></i>
                  <span>Smart scheduling based on audience engagement patterns</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#b3d9ff] text-xl mt-1"></i>
                  <span>intelligent content suggestions from connected tools</span>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-check-line text-[#b3d9ff] text-xl mt-1"></i>
                  <span>Automated workflows that learn and improve over time</span>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <div className="space-y-4">
                  <div className="flex items-center gap-4 p-4 bg-white/10 rounded-xl">
                    <div className="w-12 h-12 bg-[#1877F2]/20 rounded-lg flex items-center justify-center">
                      <i className="ri-facebook-fill text-2xl" style={{ color: '#1877F2' }}></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-sm font-semibold mb-1">Facebook Post</div>
                      <div className="flex items-center gap-2">
                        <div className="h-2 bg-[#b3d9ff] rounded-full flex-1"></div>
                        <span className="text-xs">AI Optimized</span>
                      </div>
                    </div>
                    <i className="ri-check-line text-[#b3d9ff] text-xl"></i>
                  </div>

                  <div className="flex items-center gap-4 p-4 bg-white/10 rounded-xl">
                    <div className="w-12 h-12 bg-[#E4405F]/20 rounded-lg flex items-center justify-center">
                      <i className="ri-instagram-line text-2xl" style={{ color: '#E4405F' }}></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-sm font-semibold mb-1">Instagram Reel</div>
                      <div className="flex items-center gap-2">
                        <div className="h-2 bg-[#66b3ff] rounded-full flex-1"></div>
                        <span className="text-xs">Processing</span>
                      </div>
                    </div>
                    <i className="ri-ai-generate text-[#e4f4ff] text-xl animate-pulse"></i>
                  </div>

                  <div className="flex items-center gap-4 p-4 bg-white/10 rounded-xl">
                    <div className="w-12 h-12 bg-[#0A66C2]/20 rounded-lg flex items-center justify-center">
                      <i className="ri-linkedin-fill text-2xl" style={{ color: '#0A66C2' }}></i>
                    </div>
                    <div className="flex-1">
                      <div className="text-sm font-semibold mb-1">LinkedIn Article</div>
                      <div className="flex items-center gap-2">
                        <div className="h-2 bg-white/30 rounded-full flex-1"></div>
                        <span className="text-xs">Queued</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
